import { Component, forwardRef, HostBinding, Input, Optional, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AutoComplete } from 'primeng/autocomplete';
import { of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Erma2Service } from '../../services/erma2.service';

@Component({
    selector: 'app-naseptavac-uj',
    templateUrl: './naseptavac-uj.component.html',
    styleUrls: ['./naseptavac-uj.component.css'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => NaseptavacUjComponent),
            multi: true
        }],
    standalone: false
})
export class NaseptavacUjComponent implements ControlValueAccessor {

  constructor(
    private ermaService: Erma2Service
  ) {
  }

  @ViewChild('cujAutocomplete') autoComplete: AutoComplete;

  private _value: string;
  private _id = '';
  cujs: string[] = [];
  selectedCujs: NaseptavacItems[] = [];

  // finta s ID odkoukána zde: https://coryrylan.com/blog/angular-custom-form-controls-with-reactive-forms-and-ngmodel
  @HostBinding('attr.id')
  externalId = '';

  @Input()
  set id(value: string) {
    this._id = value;
    this.externalId = null;
  }

  get id() {
    return this._id;
  }

  get value() {
    return this._value;
  }

  set value(val) {
    if (this._value != val) {
      this._value = val;
      this.onModelChange(val);
      this.onModelTouched();
    }
  }

  // Proměnné pro implementaci rozhraní ControlValueAccessor
  onModelChange: any = () => { };
  onModelTouched: any = () => { };
  disabled: boolean = false;

  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onModelTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }


  /**
   * Handler pro autocomplete CUJ. Využívá deboucing.
   * @param event
   */
  findUjs(event) {
    var firstChars: string = (event.query as string).substring(0, 6);
    var selectedItem = this.selectedCujs.find(x => x.id.toLowerCase() == firstChars.toLowerCase());//dostupný záznam pod uloženým klíčem
    var selectedCujs: string[];//nalezené cuj pod uloženým klíčem
    if (selectedItem != void 0) {//pokud existuje klíč, tak najít záznamy
      selectedCujs = selectedItem.items.filter(x => x.toLowerCase().includes(event.query.toLowerCase()));//seznam má klíče po šesti znacích. Pod klíčem ale nemusí být kompletní seznam. 
    }

    if (selectedCujs != void 0 && selectedCujs.length > 0) {//pokud nebylo nalezeno pod uloženým klíčem, tak se dotázet do db.
      this.cujs = selectedCujs;
    }
    else {
      of(event.query).pipe(
        debounceTime(5500),
        distinctUntilChanged((prev, curr) => prev == curr),
        switchMap(data => this.ermaService.getUjsByCuj(data))
      ).subscribe(resp => {
        if (resp.success) {
          this.cujs = resp.data.slice();
          if (selectedItem == void 0) {
            this.selectedCujs.push({ id: firstChars.toLowerCase(), items: this.cujs });//přidat nový klíč
          } else {
            selectedItem.items = selectedItem.items.concat(this.cujs);//přidat k už existujícímu klíči
          }
        }
      });
    }
  }
}

//objekt pro uchování seznamu uj, aby se zbytečně netahal ze serveru
interface NaseptavacItems {
  id: string;
  items: string[];
}
